import React from "react";
import ProtectedRoute from "./permitRoutes";
import NotAuthorized from "../pages/NotAuth";

const Login = React.lazy(() => import("../pages/Login"));
const Dashboard = React.lazy(() => import("../pages/Dashboard"));
const DepartmentWiseSales = React.lazy(() => import("../pages/DeptWiseSales"));
const HourlySales = React.lazy(() => import("../pages/HourlySales"));
const StockReport = React.lazy(() => import("../pages/StockReport"));
const TopSellingProducts = React.lazy(() => import("../pages/TopSellingProducts"));
const InvoiceSales = React.lazy(() => import("../pages/InvoiceSales"));
const Saleswise = React.lazy(() => import("../pages/Saleswise"));
const UsersList = React.lazy(() => import("../pages/UsersList"));
const UsersPermission = React.lazy(() => import("../pages/UsersPermission"));

const userType = parseInt(sessionStorage.getItem("userType"));

let defaultDashboard = <Login />;
if ([3, 4, 5].includes(userType)) {
  defaultDashboard = <Dashboard />;
}

const authProtectedRoutes = [
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/dept-sales", element: <DepartmentWiseSales /> },
  { path: "/hourly-sales", element: <HourlySales /> },
  { path: "/top-products", element: <TopSellingProducts /> },
  { path: "/stock-report", element: <StockReport /> },
  { path: "/invoice-sales", element: <InvoiceSales /> },
  { path: "/salesman-sales", element: <Saleswise /> },
  { path: "/users-list", element: <ProtectedRoute pageId={1}><UsersList /></ProtectedRoute> },
  { path: "/users-permission", element: <ProtectedRoute pageId={2}><UsersPermission /></ProtectedRoute> },
  { path: "/", element: defaultDashboard },
  { path: "/not-authorized", element: <NotAuthorized /> },
];

const publicRoutes = [
  { path: "/login", element: <Login /> },
];

export { authProtectedRoutes, publicRoutes };
